export default "__VITE_ASSET__7d0e9bc5__"